import { CircularProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function Loading() {
  const { t } = useTranslation();

  return (
    <Stack direction='column' spacing={3}>
      <CircularProgress />
      <Typography variant='caption' sx={{ color: 'text.secondary' }}>
        {t('readingView.menu.navigation.bookDetails.loading')}
      </Typography>
    </Stack>
  );
}
